import React, { lazy } from 'react';
import Loadable from 'src/components/Loadable';

// Admin
const ApprovalTemplateReview = Loadable(
  lazy(() => import('src/pages/admin/workflowApprovals/TemplateReview'))
);
const AppReviewPage = Loadable(
  lazy(() => import('src/pages/admin/workflowApprovals/AppReview'))
);
const MobileAppReviewPage = Loadable(
  lazy(() => import('src/pages/admin/workflowApprovals/MobileAppReviewPage'))
);
const SnippetReviewPage = Loadable(
  lazy(() => import('src/pages/admin/workflowApprovals/SnippetReviewPage'))
);
const PsAssetReview = Loadable(
  lazy(() => import('src/pages/admin/workflowApprovals/PsAssetReviewPage'))
);

const routes = [
  {
    path: 'admin/workflow-approval/review-template/:id',
    element: <ApprovalTemplateReview />
  },
  {
    path: 'admin/workflow-approval/review-feature/:id',
    element: <AppReviewPage />
  },
  {
    path: 'admin/workflow-approval/review-mobile-app/:id',
    element: <MobileAppReviewPage />
  },
  {
    path: 'admin/workflow-approval/review-snippet/:id',
    element: <SnippetReviewPage />
  },
  {
    path: 'admin/workflow-approval/review-asset/:id',
    element: <PsAssetReview />
  }
];

export default routes;
